import React, { Component } from 'react';

import classNames from 'classnames';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import { Widget as NotificationWidget } from 'modules/notification/components/widget';
import PropTypes from 'prop-types';

import HeaderEvents from './events';
import HeaderUser from './HeaderUser';

import './HeaderUserActions.scss';

class HeaderUserActions extends Component {
  static propTypes = {
    className: PropTypes.string
  };

  onNotificationWidgetClick = () => {
    HeaderEvents.sendClick({ label: 'Notifications' });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: EVENTS_CATEGORY.HORIZONTAL_MENU.NOTIFICATIONS_HORIZONTAL_MENU,
        label: EVENTS_LABELS.HORIZONTAL_MENU.NOTIFICATION_ICON,
        action: EVENTS_INTERACTIONS.CLICK
      })
    });
  };

  onAccountClick = () => {
    HeaderEvents.sendClick({ label: 'Account' });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: EVENTS_CATEGORY.HORIZONTAL_MENU.HORIZONTAL_MENU_ACCOUNT,
        label: EVENTS_LABELS.HORIZONTAL_MENU.ACCOUNT,
        action: EVENTS_INTERACTIONS.CLICK
      })
    });
  };

  render() {
    const { className } = this.props;
    const classComponent = classNames('header__user__actions', className);

    return (
      <div className={classComponent}>
        <NotificationWidget onClick={this.onNotificationWidgetClick} />
        <HeaderUser onClick={this.onAccountClick} />
      </div>
    );
  }
}

export default HeaderUserActions;
